import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { BRIEF_DEBUG_DATA_VISIBLE } from 'src/lib/featureFlags';

const MUTATION = gql`
  mutation SuggestBlogPostBuilderIntroSection(
    $projectId: ID!
    $debugAcPrompt: String
    $generationLength: String!
    $instruction: String
    $markedSegmentStart: Int
    $markedSegmentEnd: Int
    $previousResults: [String!]
    $keywords: [String!]
  ) {
    suggestBlogPostBuilderIntroSection(
      projectId: $projectId
      debugAcPrompt: $debugAcPrompt
      generationLength: $generationLength
      instruction: $instruction
      markedSegmentStart: $markedSegmentStart
      markedSegmentEnd: $markedSegmentEnd
      previousResults: $previousResults
      keywords: $keywords
    ) {
      copyText
      keywordsUsage
    }
  }
`;

const prepareContext = (projectId, params) => {
  if (!BRIEF_DEBUG_DATA_VISIBLE) {
    return null;
  }

  const title = `"suggest blog builder intro section" request [projectId: ${projectId}, assetType: blog_post_content, params: ${JSON.stringify(
    params
  )}]`;
  return { traceAuthorComplete: true, traceAuthorCompleteTitle: title };
};

export const suggestBlogPostBuilderIntroSection = (projectId, params) => {
  const markedSegmentEnd =
    (params.markedSegment && params.markedSegment.end) || null;
  const markedSegmentStart = markedSegmentEnd
    ? params.markedSegment.start
    : null;
  const previousResults =
    (params.markedSegment && params.markedSegment.previousResults) || [];
  return apolloClient
    .mutate({
      mutation: MUTATION,
      variables: {
        projectId,
        debugAcPrompt: params.debugAcPrompt,
        generationLength: params.generationLength,
        instruction: params.instruction,
        markedSegmentStart,
        markedSegmentEnd,
        previousResults,
        keywords: params.keywords,
      },
      context: prepareContext(projectId, params),
    })
    .then((response) => {
      const parsedRes = getSingleProp(response.data);
      return {
        ...parsedRes,
        keywordsUsage: parsedRes.keywordsUsage
          ? JSON.parse(parsedRes.keywordsUsage)
          : null,
      };
    });
};
